<template>
  <div style="margin: 0 auto 5rem; max-width: 960px">
    <HeaderBar
      view="save"
      :showBar="showHeaderBar"
      @discard="discardModalOpen = true"
      @save="handleSaveChanges($route.params.name)"
    />
    <BackButton
      link="/our-public-profiles"
      text="Back to Our public profiles"
    />
    <ProfileHeading
      :heading="profileHeadingName"
      :featured-badge="profileData.featured"
      :main-badge="{
        text: badgeStatusFilter('status'),
        class: badgeStatusFilter('statusClass'),
      }"
      :profile-link="{
        href: profileLink,
        text: profileData.status === 'H' ? 'Preview profile' : 'View profile',
        showPreviewIcon:
          profileData.status === 'H' || profileData.status === 'N',
      }"
    />
    <div v-if="isVendorProfile">
      <hr style="margin: 2rem 0 !important" />
      <AboutContentSection
        namespace="ourPublicProfiles/detail"
        :vendorOPP="true"
        :key="aboutSectionKey"
      />
      <QuoteContentSection
        heading="Testimonial"
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <VideoContentSection
        namespace="ourPublicProfiles/detail"
        :vendorOPP="true"
        @delete-content="deleteContent"
      />
      <MediaContentSection
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <UseCaseContentSection
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <ResourcesContentSection
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <SupportContentSection namespace="ourPublicProfiles/detail" />
      <CTAContentSection
        namespace="ourPublicProfiles/detail"
        :globalCtaUrl="profileData.directoryGlobalCtaUrl"
        :globalCtaText="profileData.directoryGlobalCtaText"
      />

      <FiltersContentSection
        heading="Categories and collections"
        namespace="ourPublicProfiles/detail"
        :vendorOPP="isVendorProfile"
        :options="[
          { label: 'Categories', id: 'categories' },
          { label: 'Collections', id: 'collections' },
        ]"
      />
      <div style="display: flex; justify-content: flex-end; margin-top: 2rem">
        <Button
          v-on:button-click="saveChanges($route.params.name)"
          type="button"
        >
          Save
        </Button>
      </div>
    </div>

    <div v-else>
      <AboutContentSection
        namespace="ourPublicProfiles/detail"
        :OPP="true"
        :integrationPartner="false"
        :managePartners="false"
        :vendorOPP="isVendorProfile"
        @url-error="urlError = true"
        @no-url-error="urlError = false"
        :key="aboutSectionKey"
      />
      <QuoteContentSection
        namespace="ourPublicProfiles/detail"
        :agencyOPP="true"
        @delete-content="deleteContent"
      ></QuoteContentSection>
      <UseCaseContentSection
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <ResourcesContentSection
        namespace="ourPublicProfiles/detail"
        @delete-content="deleteContent"
      />
      <CTAContentSection namespace="ourPublicProfiles/detail" />

      <CategoriesContentSection
        v-if="categories && categories.length > 0"
        namespace="ourPublicProfiles/detail"
        :categories="categories"
        :profile-categories="profileData.categories"
      />

      <div class="button-wrapper">
        <Button
          v-on:button-click="saveChanges($route.params.name)"
          type="button"
        >
          Save
        </Button>
      </div>
    </div>
    <DSModal
      v-if="modalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      :title="modalOpen.title"
      :description="modalOpen.description"
      @close-modal="modalOpen = false"
      @primary-click="confirmedDelete"
      @secondary-click="modalOpen = false"
    />
    <DSModal
      v-if="modalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      :title="modalOpen.title"
      :description="modalOpen.description"
      @close-modal="modalOpen = false"
      @primary-click="confirmedDelete"
      @secondary-click="modalOpen = false"
    />

    <DSModal
      v-if="discardModalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      title="Discard changes?"
      description="Are you sure you want to discard all the changes?"
      @close-modal="discardModalOpen = false"
      primaryText="Discard changes"
      secondaryText="Cancel"
      @primary-click="discardChanges"
      @secondary-click="discardModalOpen = false"
    />
  </div>
</template>

<script>
import HeaderBar from '@/components/DesignSystem/HeaderBar';
import Button from '@/components/DesignSystem/Button';
import DSModal from '@/components/DesignSystem/Modal';
import BackButton from '@/components/BackButton';
import { createNamespacedHelpers } from 'vuex';
import MediaContentSection from '@/components/Shared/ContentSection/MediaContentSection';
import CategoriesContentSection from '@/components/Shared/ContentSection/CategoriesContentSection';
import VideoContentSection from '@/components/Shared/ContentSection/VideoContentSection';
import QuoteContentSection from '@/components/Shared/ContentSection/QuoteContentSection';
import ResourcesContentSection from '@/components/Shared/ContentSection/ResourcesContentSection';
import AboutContentSection from '@/components/Shared/ContentSection/AboutContentSection';
import UseCaseContentSection from '@/components/Shared/ContentSection/UseCaseContentSection';
import CTAContentSection from '@/components/Shared/ContentSection/CTAContentSection';
import FiltersContentSection from '@/components/Shared/ContentSection/FiltersContentSection';
import SupportContentSection from '@/components/Shared/ContentSection/SupportContentSection';
import { filtersOptions } from '@/views/Dashboard/OurPublicProfiles/FiltersOptions';
import { removeDoubleBackslash } from '@/store/vendorDashboard/getters';
import ProfileHeading from '@/components/Shared/ContentSection/ProfileHeading';
const { mapGetters, mapActions } = createNamespacedHelpers('ourPublicProfiles');

export default {
  components: {
    ProfileHeading,
    CategoriesContentSection,
    SupportContentSection,
    FiltersContentSection,
    CTAContentSection,
    UseCaseContentSection,
    AboutContentSection,
    MediaContentSection,
    VideoContentSection,
    QuoteContentSection,
    ResourcesContentSection,
    HeaderBar,
    Button,
    DSModal,
    BackButton,
  },
  data() {
    return {
      discardModalOpen: false,
      urlError: false,
      modalOpen: false,
      toDelete: undefined,
      deleteType: undefined,
      aboutSectionKey: 1,
    };
  },
  filters: {
    ...filtersOptions,
  },
  methods: {
    removeDoubleBackslash,
    ...mapActions({
      clearData: 'detail/clearData',
      clearPartner: 'detail/clearPartner',
      saveChanges: 'detail/saveChanges',
      fetchProfile: 'detail/fetchProfile',
      fetchUseCases: 'detail/fetchUseCases',
      fetchQuotes: 'detail/fetchQuotes',
      fetchResources: 'detail/fetchResources',
      fetchButton: 'detail/fetchButton',
      fetchSupport: 'detail/fetchSupport',
      fetchMediaContent: 'detail/fetchMediaContent',
    }),

    handleUrlError(key, value) {
      this.$store.commit('ourPublicProfiles/detail/handleError', {
        key,
        value,
      });
    },
    confirmedDelete() {
      if (this.deleteType === 'media') {
        this.$store.dispatch(
          'ourPublicProfiles/detail/deleteItemForMedia',
          this.toDelete
        );
      }

      if (this.deleteType === 'video' || this.deleteType === 'videos') {
        this.$store.dispatch(
          'ourPublicProfiles/detail/deleteVideo',
          this.toDelete
        );
      }

      if (this.deleteType === 'testimonials') {
        this.$store.dispatch(
          'ourPublicProfiles/detail/deleteItemForTestimonial',
          this.toDelete
        );
      }

      if (this.deleteType === 'resources') {
        this.$store.dispatch(
          'ourPublicProfiles/detail/deleteItemForResources',
          this.toDelete
        );
      }
      if (this.deleteType === 'useCases') {
        this.$store.dispatch(
          'ourPublicProfiles/detail/deleteItemForUseCases',
          this.toDelete
        );
      }

      this.modalOpen = false;
      this.toDelete = false;
    },

    handleSaveChanges(id) {
      if (this.urlError) {
        this.$store.dispatch('showUserMessage', {
          success: false,
          title: 'Oops!',
          message: 'Please enter your Company website',
        });
        return;
      }

      this.saveChanges(id);
    },

    discardChanges() {
      this.fetchData();
      this.$store.commit('ourPublicProfiles/detail/clearDirtyTabs');
      this.$store.commit('ourPublicProfiles/detail/clearErrors');
      this.discardModalOpen = false;
      this.aboutSectionKey += 1;
    },

    deleteContent(payload) {
      this.toDelete = payload;
      this.modalOpen = {
        title: payload.modalTitle,
        description: payload.modalDescription,
      };
      this.deleteType = payload.section;
    },

    async fetchData() {
      await this.fetchProfile(this.$route.params.name);
      this.fetchUseCases(this.$route.params.name);
      this.fetchQuotes(this.$route.params.name);
      this.fetchResources(this.$route.params.name);
      this.fetchButton(this.$route.params.name);
      this.fetchSupport(this.$route.params.name);
      if (this.isVendorProfile) {
        this.fetchMediaContent(this.$route.params.name);
      }
    },
    badgeStatusFilter(filter) {
      return this.$options.filters[filter](this.profileData.status);
    },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters({
      activeProfile: 'activeProfile',
      profileData: 'detail/profileData',
      profileUrl: `detail/profileUrl`,
      showHeaderBar: 'detail/showHeaderBar',
      isVendorProfile: 'detail/isVendor',
      categories: 'detail/categories',
    }),
    loggedInVendor() {
      return (
        sessionStorage.getItem('vendorName') ||
        this.$store.getters['details'].vendorData.name
      );
    },
    profileHeadingName() {
      if (this.isVendorProfile) {
        return this.profileData.directoryVendorName;
      }
      return this.profileData.directoryAgencyName;
    },
    profileLink() {
      if (this.isVendorProfile) {
        const partnerpageUrl = this.profileData.directoryPartnerpageUrl || '';
        if (
          this.profileData.status === 'H' ||
          this.profileData.status === 'N'
        ) {
          const link =
            'https://' +
            partnerpageUrl +
            '.partnerpage.io/preview/integrations/' +
            this.profileData.vendorSlug +
            '/' +
            this.profileData.id;
          return this.removeDoubleBackslash(link);
        }
        return (
          'https://' +
          partnerpageUrl +
          '.partnerpage.io/integrations/' +
          this.profileData.vendorSlug
        );
      } else {
        if (
          this.profileData.status === 'H' ||
          this.profileData.status === 'N'
        ) {
          let link =
            'https://' +
            this.profileData.directoryPartnerpageUrl +
            '.partnerpage.io/preview/agency/' +
            this.profileData.vendorSlug +
            '/' +
            this.profileData.agencyDirectory;
          return this.removeDoubleBackslash(link);
        }
        return (
          'https://' +
          this.profileData.directoryPartnerpageUrl +
          '.partnerpage.io/' +
          this.profileData.vendorSlug
        );
      }
    },
    vendor() {
      return this.$route.params.name;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearPartner();
    this.clearData();
    next();
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 2rem 0;
}

.route-enter-active,
.route-leave-active {
  transition-duration: 0.1s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.1s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
